import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { authAPI } from '../services/api';
import { useAuthStore } from '../store/authStore';
import toast from 'react-hot-toast';

export const useLogin = () => {
  const login = useAuthStore((state) => state.login);
  
  return useMutation({
    mutationFn: authAPI.login,
    onSuccess: (response) => {
      const { user, token } = response.data.data!;
      login(user, token);
      toast.success('Succesvol ingelogd!');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.message || 'Login mislukt');
    },
  });
};

export const useRegister = () => {
  const login = useAuthStore((state) => state.login);
  
  return useMutation({
    mutationFn: authAPI.register,
    onSuccess: (response) => {
      const { user, token } = response.data.data!;
      login(user, token);
      toast.success('Account succesvol aangemaakt!');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.message || 'Registratie mislukt');
    },
  });
};

export const useLogout = () => {
  const logout = useAuthStore((state) => state.logout);
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: authAPI.logout,
    onSuccess: () => {
      logout();
      queryClient.clear();
      toast.success('Uitgelogd');
    },
    onError: () => {
      // Force logout even if API call fails
      logout();
      queryClient.clear();
    },
  });
};

export const useMe = () => {
  const { isAuthenticated } = useAuthStore();
  
  return useQuery({
    queryKey: ['me'],
    queryFn: () => authAPI.me().then(res => res.data.data),
    enabled: isAuthenticated,
    retry: false,
  });
};
